module.exports = __webpack_public_path__ + "img/LOGO.644a1fb3.png";